import { Icon, type IconName } from "@/components/ui/Icon";

/**
 * The small coloured square that represents a workspace across the app — shows
 * the chosen Lucide icon when set, else the workspace's initials. One component
 * so the Topbar switcher, the workspace menu, Home, and the request cards all
 * render workspaces identically.
 */
export function WorkspaceBadge({
  name,
  icon,
  color,
  size = 18,
}: {
  name: string;
  icon?: string | null;
  color: string;
  size?: number;
}) {
  const initials =
    name
      .split(" ")
      .map((w) => w[0])
      .filter(Boolean)
      .slice(0, size < 24 ? 1 : 2)
      .join("")
      .toUpperCase() || "?";
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size >= 28 ? 7 : 4,
        background: color,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: Math.max(9, Math.round(size * 0.42)),
        fontWeight: 700,
        flexShrink: 0,
        transform: "skewX(-12deg)",
      }}
    >
      {/* Counter-skew so the icon/initials stay upright inside the Raute tile. */}
      <span
        style={{
          transform: "skewX(12deg)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon ? (
          <Icon name={icon as IconName} size={Math.round(size * 0.62)} color="#fff" />
        ) : (
          initials
        )}
      </span>
    </div>
  );
}
